import { Component, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { CategoryInterface } from '../../../domain/entites/HeaderThemes.model';
import { GET_CATEGORIES_HEADER_ACTION } from '../../../domain/facades/store/HeaderThemes.actions';
import { CATEGORIES_HEADER_SELECTOR } from '../../../domain/facades/store/HeaderThemes.selectors';
import { Router } from '@angular/router';
import { BaseComponent, LanguageService } from 'imakeapp-shared';








@Component({
  selector: 'app-header-two',
  templateUrl: './header-two.component.html',
  styleUrls: ['./header-two.component.scss'],
})
export class HeaderTwoComponent extends BaseComponent implements OnInit
{

  @ViewChild('menu') menu: any;
  @ViewChild('cat') cat: any;
  @ViewChild('active') active: any;



  lazyLoadImage = '../../../../../assets/loading.gif';
  categories: CategoryInterface[] = [];
  active_cat: CategoryInterface = {
      id: 0,
      name: '',
      name_en: '',
      name_ar: '',
      menu_photo: '',
      sub_categories: [],
      subCategory: []
  };





  constructor(
    private store: Store,
    public router: Router,
    private cookie_s: CookieService,
    public override language_s: LanguageService
  ) {
    super(language_s);
  }

  override ngOnInit(): void
  {

    this.set_language();

    this.get_data();

    this.listen_to_data();

  }






  get_data()
  {

    this.store.dispatch( new GET_CATEGORIES_HEADER_ACTION() );


  }


  listen_to_data()
  {

    this.store.pipe( select(CATEGORIES_HEADER_SELECTOR) ).subscribe(
      (categories: any)=>{
        if ( !categories?.length ) return;

        // save categories
        this.categories = categories;

        // set init category
        if ( categories.length != 0 )
        {
          this.active_cat = this.categories[0];
        }

      }

    );

  }

  hoverTimer: any;

  onMouseEnter(isShow: boolean): void {

    if ( !this.menu ) return;

    this.hoverTimer = setTimeout(() => {
      // Handle the long hover event logic here
      this.menu.nativeElement.classList.add('menu_show');

      // Additional code...
    }, 500); // Set the duration for long hover (in milliseconds)
  }


  onMouseEnterNoDelay(isShow: boolean): void {
    this.menu.nativeElement.classList.add('menu_show');
  }

  onMouseLeave(): void {
    if ( !this.menu ) return;
    this.menu.nativeElement.classList.remove('menu_show');
    clearTimeout(this.hoverTimer);
  }

  override ngOnDestroy(): void {
    clearTimeout(this.hoverTimer);
  }

  showCat(isShow: boolean) {
    if (isShow) this.cat.nativeElement.classList.add('menu_show');
    else this.cat.nativeElement.classList.remove('menu_show');
  }

  showelement(isShow: boolean, i: number) {

  }
  public swtichToProductList(SubId:number){
console.log(SubId)
    this.router!!.navigate(['/products/products-list'],  {
      queryParams:  {  SubCatId:  SubId},
    });
  }
  public swtichToProductListForCat(CatId:number){
    this.router!!.navigate(['/products/products-list'],  {
      queryParams:  {  category_id:  CatId},
    });
  }
  get_sub_cat(cat: any)
  {

    // set active cat
    this.active_cat = cat;


  }




}
